module.exports = __webpack_public_path__ + "static/img/bround.d55bc1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/bround.png
// module id = Hsb9
// module chunks = 208